/*
 * PRC custom scripts — rewritten vanilla JS for the Impulse 9.1.0 upgrade
 * (previously jQuery-based). Loaded via snippets/prc-header-assets.liquid.
 */

// Initialize tippy tooltips on any [data-tippy-content] elements (header icons, etc.)
document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.tippy === 'function') {
    window.tippy('[data-tippy-content]');
  }
});

// Expandable "hidden block" text: clicking .hidden-block-show toggles the
// adjacent .hidden-block-text element (replaces jQuery .next().slideToggle()).
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.hidden-block-show');
  if (!trigger) return;
  e.preventDefault();
  var target = trigger.nextElementSibling;
  if (target && target.classList.contains('hidden-block-text')) {
    target.style.display = (target.style.display === 'block') ? 'none' : 'block';
  }
});

// "Read More" for team bios (About page). Bios are text-columns blocks whose <h3> title uses a
// "Name | Role" format. Keep the FIRST paragraph visible and tuck the remaining paragraphs into
// a wrapper that expands inline (page reflows down) with a smooth max-height transition — so the
// split lands at a clean paragraph boundary, never mid-sentence.
document.addEventListener('DOMContentLoaded', function () {
  var blocks = document.querySelectorAll('.text-column__grid > div');
  Array.prototype.forEach.call(blocks, function (block) {
    var h3 = block.querySelector('h3');
    var rte = block.querySelector('.rte-setting');
    if (!h3 || !rte) return;
    if (h3.textContent.indexOf('|') === -1) return; // bios only ("Name | Role")

    var paras = rte.querySelectorAll(':scope > p');
    if (paras.length < 2) return; // single paragraph -> nothing to collapse

    // Move paragraphs after the first into a collapsible wrapper.
    var wrap = document.createElement('div');
    wrap.className = 'prc-bio-more';
    rte.insertBefore(wrap, paras[1]);
    for (var i = 1; i < paras.length; i++) wrap.appendChild(paras[i]);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prc-bio-toggle';
    btn.textContent = 'Read More';
    btn.setAttribute('aria-expanded', 'false');

    // After opening, drop the fixed height so the content can reflow freely (e.g. on resize).
    wrap.addEventListener('transitionend', function () {
      if (btn.getAttribute('aria-expanded') === 'true') wrap.style.maxHeight = 'none';
    });

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        wrap.style.maxHeight = wrap.scrollHeight + 'px'; // from 'none' -> fixed, then animate to 0
        void wrap.offsetHeight;
        wrap.style.maxHeight = '0';
        btn.textContent = 'Read More';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        btn.textContent = 'Read Less';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    rte.parentNode.insertBefore(btn, rte.nextSibling);
  });
});
